/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ProgramId } from "../../commons/types/ProgramId";
export const TransformationProgramJobConfig = core.serialization.object({
    programId: ProgramId,
});
